module.exports = __webpack_public_path__ + "img/Slajd15.72e902ca.jpeg";